module.exports = __webpack_public_path__ + "static/media/dinesh.fc193ab5.jpg";